import React, { Component } from 'react'
import { Button, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import '../css/UpdateUserProfile.css';
import axiosConfig from '../config/axiosConfig'
import Swal from 'sweetalert2/dist/sweetalert2.js';
import AdvanceTableWithDeleteButton from '../components/Tables/AdvanceTableWithDeleteButton';

import '../css/AdvanceDeleteButtonTable.css'
import FeatherIcon from 'feather-icons-react'
import { Link } from 'react-router-dom'; // Add this line



class UpdateUserProfile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            MobileName: '',
            EmailName: '',
            firstName: '',
            middleName: '',
            lastName: '',
            email: '',
            mobileNo: '',
            mobileNo1: '',
            mobileNo2: '',
            email1: '',
            email2: '',
            UserID: 0,

            openModel: false,
            openModelEmail: false,

            SMSdata: [],
            Emaildata: [],
            SMScolumns: [
                { "HeaderText": "ID", "MappingColomn": "id" },
                { "HeaderText": "Name", "MappingColomn": "name" },
                { "HeaderText": "Contact No", "MappingColomn": "contactNo" }
               

            ],
            Emailcolumns: [
                { "HeaderText": "ID", "MappingColomn": "id" },
                { "HeaderText": "Name", "MappingColomn": "name" },
                { "HeaderText": "Email", "MappingColomn": "email" }


            ],
            DeletedSMSId: 0,
            DeletedEmailId: 0,

            BranchID: '',
            UserBranchID: localStorage.getItem("selectedBranch")
        }


        this.changeHandler = this.changeHandler.bind(this);
        this.submitHandler = this.submitHandler.bind(this);

        this.showModel = this.showModel.bind(this)
        this.closeModel = this.closeModel.bind(this)

        this.showModelEmail = this.showModelEmail.bind(this)
        this.closeModelEmail = this.closeModelEmail.bind(this)
        this.onChange = this.onChange.bind(this)
        this.SMSSaved = this.SMSSaved.bind(this)
        this.EmailSaved = this.EmailSaved.bind(this)
        this.BindSMSAndEmailGrid = this.BindSMSAndEmailGrid.bind(this);

        this.GetDeleteSelectedRecords_Email = this.GetDeleteSelectedRecords_Email.bind(this);
        this.GetDeleteSelectedRecords_SMS = this.GetDeleteSelectedRecords_SMS.bind(this);
        
        
    }
    

     
    componentWillMount() {

    }
    componentDidMount() {

        this.setState({ BranchID: localStorage.getItem('selectedBranch') })

        let token = localStorage.getItem('token')
        let userData = JSON.parse(localStorage.getItem('userData'))
        let name = userData.name.split(" ")
        /*Added By Ishfaque Kazi on 23rd of April 2021*/
        axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig.get("Portal/GetUserProfile")
            .then(res => {
                this.setState({
                    email: res.data.email,
                    firstName: res.data.firstName,
                    lastName: res.data.lastName,
                    UserID: res.data.userID
                })

            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })

        this.BindSMSAndEmailGrid();
    }

    BindSMSAndEmailGrid(e) {
        let token = localStorage.getItem('token')
        axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig.post("Portal/GetUserContact")
            .then(res => {
                this.setState({
                    SMSdata: res.data.userContact,
                    UserBranchID: this.state.UserBranchID
                })

            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })


        axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig.post("Portal/GetUserEmail")
            .then(res => {
                this.setState({
                    Emaildata: res.data.userEmail,
                    UserBranchID: this.state.UserBranchID
                })

            })
            .catch(error => {

                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })
    }

    showModel(e) {
        debugger
        this.setState({ openModel: true });
    }

    closeModel(e) {
        
        this.setState({ openModel: false });
        this.setState({ MobileName : ''});
        this.setState({mobileNo1:''});
    }

    showModelEmail(e) {
        debugger
        this.setState({ openModelEmail: true });
    }

    closeModelEmail(e) {
        this.setState({ openModelEmail: false });
       
        this.setState({ email1: '' })
        this.setState({ EmailName: '' })
    }

    changeHandler(p) {
        var newState = {};
        newState[p.target.name] = p.target.value;
        this.setState(newState);
    }

    submitHandler = e => {
        e.preventDefault();

        axiosConfig.post("User/UserProfileUpdate",
            {
                UserID: this.state.UserID,
                FirstName: this.state.firstName,
                MiddleName: '',
                LastName: this.state.lastName,
                Email: this.state.email,
                MobileNo: this.state.mobileNo,
                CreatedBy: localStorage.getItem('userid'),
                MobileNo1: this.state.mobileNo1,
                MobileNo2: this.state.mobileNo2,
                Email1: this.state.email1,
                Email2: this.state.email2,
                UserBranchID: this.state.UserBranchID
            }
        )
            .then(Response => {

                Swal.fire({
                    icon: 'success',
                    title: 'Profile Updated Successfully',
                })
            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })
    }



    SMSSaved = e => {
        e.preventDefault();
        debugger
        axiosConfig.post("Portal/SaveProfileAlert",
            {
                UserID: localStorage.getItem('userid'),
                Name: this.state.MobileName,
                Value: this.state.mobileNo1,
                ChannelTypeId: 1,
                UserBranchID: this.state.UserBranchID
            }

        )
            .then(Response => {
                debugger
                this.setState({ openModel: false });
                this.BindSMSAndEmailGrid();
                Swal.fire({
                    icon: 'success',
                    title: Response.data.status.description,
                })

                //this.setState({MobileName: ''})
                
                this.setState({ MobileName: '' })
                this.setState({ mobileNo1: '' })
            })
            .catch(error => {
                this.setState({ openModel: false });
                Swal.fire({
                    title: error.response.data.status.description,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })
    }

    EmailSaved = e => {

        e.preventDefault();
        axiosConfig.post("Portal/SaveProfileAlert",
            {
                UserID: localStorage.getItem('userid'),
                Name: this.state.EmailName,
                Value: this.state.email1,
                ChannelTypeId: 2,
                UserBranchID: this.state.UserBranchID
            }
        )
            .then(Response => {
                this.setState({ openModelEmail: false });
                this.BindSMSAndEmailGrid();
                Swal.fire({
                    icon: 'success',
                    title: Response.data.status.description,
                })

                this.setState({ email1: '' })
                this.setState({ EmailName: '' })
            })
            .catch(error => {
                this.setState({ openModelEmail: false });
                Swal.fire({
                    title: error.response.data.status.description,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })
    }

    onChange(e) {
        var newState = {};
        newState[e.target.name] = e.target.value;
        this.setState(newState);
    }
    GetDeleteSelectedRecords_Email = (childData) => {
        this.setState({ DeletedEmailId: childData.id });

        let token = localStorage.getItem('token')
        axiosConfig.defaults.headers.common['Token'] = token;
        const data = {
            UserProfileId: this.state.DeletedEmailId,
            UserBranchID: this.state.UserBranchID
        }
        axiosConfig.post("Portal/DeactiveProfileAlert", data)
            .then(res => {
                this.BindSMSAndEmailGrid();
                Swal.fire(
                    'Deleted!',
                    'Email has been deleted.',
                    'success'
                )
            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })


    }

    GetDeleteSelectedRecords_SMS = (childData) => {

        this.setState({ DeletedSMSId: childData.id })


        const data = {
            UserProfileId: this.state.DeletedSMSId,
            UserBranchID: this.state.UserBranchID
        }
        axiosConfig.post("Portal/DeactiveProfileAlert", data)
            .then(res => {
                this.BindSMSAndEmailGrid();
                Swal.fire(
                    'Deleted!',
                    'SMS Mobile No has been deleted.',
                    'success'
                )
            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })
    }


    render() {

        const { firstName, middleName, lastName, email, mobileNo, mobileNo1, mobileNo2, email1, email2, MobileName, EmailName } = this.state;

        return (
            <>
                {/* 
                <CustomHeader>

                </CustomHeader> */}
        <div style={{ textAlign: 'left', marginLeft: '30px' }}>

                <Link to="/manage" className="btn btn-shell mr-1 mb-1">Back</Link> {/* Add this line */}
 
                </div>

                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title"> <h4>My Profile</h4></h4>
                                </div>
                                <div className="card-content">
                                    <div className="card-body"></div>
                                    <form className="form" onSubmit={this.submitHandler} >
                                        <div className="form-body">
                                            <div className="row">
                                                <div className="col-md-6 col-12">
                                                    <div className="form-label-group">
                                                        <label htmlFor="city-column">Email</label>
                                                        <input type="text" id="email" name="email" className="form-control" value={this.state.email} readOnly />
                                                    </div>
                                                </div>

                                                <div className="col-md-6 col-12">
                                                    &nbsp;
                                                </div>

                                                <div className="col-md-6 col-12">
                                                    <div className="form-label-group">
                                                        <input type="text" id="firstName" name="firstName" className="form-control" value={this.state.firstName} onChange={this.changeHandler} maxLength="25" />
                                                        <label>First Name</label>
                                                    </div>
                                                </div>

                                                <div className="col-md-6 col-12">
                                                    <div className="form-label-group">
                                                        <input type="text" id="lastName" name="lastName" className="form-control" value={this.state.lastName} onChange={this.changeHandler} maxLength="25" />
                                                        <label htmlFor="last-name-column">Last Name</label>
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <button type="submit" className="btn btn-shell mr-1 mb-1">Save Details</button>
                                                </div>


                                                <div className="col-md-12 col-12 mb-4" style={{ textAlign: 'left' }}>
                                                    <h5>Profile for Alerts</h5>
                                                    <h7>Alerts can only be received for Suspicious Transactions once they have been enabled from the ‘Manage Suspicious Transactions’ section.</h7>
                                                </div>


                                            </div>
                                        </div>
                                    </form>


                                    <div class="row">
                                        <div  className="col-md-6 col-12" style={{textAlign:'left'}}>
                                            <h6 className='mb-0' style={{fontWeight:600}}>SMS Details</h6>
                                            
                                            <h7>Add SMS Profile     </h7>
                                            <a href="#" onClick={this.showModel}><FeatherIcon className="iconspacing pull-right" style={{float:'revert'}} icon="plus-square" size="20" color="green" /></a>
                                            </div>
                                            
                                            <div className="col-md-6 col-12" style={{textAlign:'left'}}>
                                            
                                            <h6 className='mb-0' style={{fontWeight:600}}>Email Details</h6>
                                            <h7>Add Email Profile    </h7>
                                            <a href="#" onClick={this.showModelEmail}><FeatherIcon className="iconspacing pull-right" style={{float:'revert'}} icon="plus-square" size="20" color="green" /></a>
                                            </div>
                                                
                                            <div className="col-md-6 col-12">
                                            <AdvanceTableWithDeleteButton parentDeletedObjectCallback={this.GetDeleteSelectedRecords_SMS} data={this.state.SMSdata} columns={this.state.SMScolumns}>
                                            </AdvanceTableWithDeleteButton>
                                        </div>
                                        
                                        
                                           
                                            <div className="col-md-6 col-12">
                                            <AdvanceTableWithDeleteButton parentDeletedObjectCallback={this.GetDeleteSelectedRecords_Email} data={this.state.Emaildata} columns={this.state.Emailcolumns}>
                                            </AdvanceTableWithDeleteButton>

                                        </div>

                                    </div>





                                </div>
                            </div>
                        </div>
                    </div>

                    <Modal show={this.state.openModel} onHide={this.closeModel} animation={true} centered style={{ zIndex: 99999 }}>
                        <Modal.Header closeButton>
                            <Modal.Title>Profile For SMS </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form onSubmit={this.SMSSaved}>
                                <div className="modal-body">
                                    <label>Name: </label>
                                    <div className="form-group">
                                        <input type="text" placeholder="Enter Name" className="form-control" name="MobileName" value={this.state.MobileName} onChange={this.onChange} required maxLength="50" />
                                    </div>
                                    <label>Mobile: </label>
                                    <div className="form-group">
                                        <input type="tel" placeholder="03xxxxxxxxx" className="form-control" name="mobileNo1" pattern= "^03[0-9]{2}[0-9]{7}$"  /*"[0-9]{4}[0-9]{7}"*/
                                        value={this.state.mobileNo1} onChange={this.onChange}  required/>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <Button variant="secondary" onClick={this.closeModel}>Close</Button>
                                    <button className="btn btn-shell" >Submit</button>
                                </div>
                            </form>
                        </Modal.Body>
                    </Modal>

                    <Modal show={this.state.openModelEmail} onHide={this.closeModelEmail} animation={true} centered style={{ zIndex: 99999 }}>
                        <Modal.Header closeButton>
                            <Modal.Title>Profile For Email </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form onSubmit={this.EmailSaved}>
                                <div className="modal-body">
                                    <label>Name: </label>
                                    <div className="form-group">
                                        <input type="text" placeholder="Enter Name" className="form-control" name="EmailName" value={this.state.EmailName} onChange={this.onChange} required maxLength="50" />
                                    </div>
                                    <label>Email: </label>
                                    <div className="form-group">
                                        <input autoComplete="false" type="email" placeholder="Enter Email" className="form-control" name="email1" value={this.state.email1} onChange={this.onChange} required />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <Button variant="secondary" onClick={this.closeModelEmail}>Close</Button>
                                    <button type="submit" className="btn btn-shell">Submit</button>
                                </div>
                            </form>
                        </Modal.Body>
                    </Modal>


                </section>

            </>

        );
    }
}

export default UpdateUserProfile;









